export default __webpack_public_path__ + "static/media/award-3.3413bd80.png";